// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/Admin Login.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loginOtpModal {
    width: 100%;
    height: 100vh;
    background-color: #00000099;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
}

.otp_container {
    width: 520px;
    height: fit-content;
    background-color: #ffffff;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-repeat: no-repeat;
    border: 4px solid #FFFFFF;
    border-radius: 20px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    gap: 8px;
    padding: 20px; 
    position: relative;     
    box-sizing: border-box;
}

.otp_container > h1 {
    font-size: 24px;
    font-weight: 500;
    color: #000000;
    text-align: center;
    margin: 0;
}

.otp-input-box {
    width: 100%;
    box-sizing: border-box;
}

.otp-input-box > div {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    flex-wrap: nowrap;
    width: 100%;
}

.otp-input-box > div > input {
    width: 34px !important;
    height: 42px !important;
    border: 1px solid #515151;
    border-radius: 6px;
    font-size: 20px;
    font-weight: 700;
    font-family: 'Quicksand';
    margin: 0 !important;
    background-color: transparent;
    text-align: center;
    outline: none;
    flex-shrink: 0;
    box-sizing: border-box;
}

.otp-input-box > div > input:focus {
    border-color: #234B9A;
    border-width: 2px;
}

.otpreset {
    color: #43454A;
    font-size: 16px;
    font-weight: 400;
    text-align: center;
    margin: 0;
}

.otpreset button {
    color: #234B9A;
    font-size: 20px;
    font-weight: 600;
    cursor: pointer;
    border: none;
    background-color: transparent;
}

.resendbtn{
    font-size: 16px;
}

.closeModal {
    position: absolute;
    top: 12px;
    right: 16px;
    width: fit-content;
    height: fit-content;
    font-size: 25px;
    font-weight: 600;
}

.closeModal svg {
    cursor: pointer;
}

@media (max-width: 560px) {
    .otp_container {
        width: 95vw;
        padding: 16px 10px 24px 10px;
        gap: 14px;
    }

    .otp-input-box > div > input {
        width: 24px !important;
        height: 34px !important;
        font-size: 14px;
        border-radius: 5px;
    }

    .otp-input-box > div {
        gap: 4px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/PopUpModal/OtpModal.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,2BAA2B;IAC3B,eAAe;IACf,MAAM;IACN,OAAO;IACP,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,yDAAsD;IACtD,sBAAsB;IACtB,4BAA4B;IAC5B,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,aAAa;IACb,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,wBAAwB;IACxB,oBAAoB;IACpB,6BAA6B;IAC7B,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI;QACI,WAAW;QACX,4BAA4B;QAC5B,SAAS;IACb;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,QAAQ;IACZ;AACJ","sourcesContent":[".loginOtpModal {\n    width: 100%;\n    height: 100vh;\n    background-color: #00000099;\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 9999;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.otp_container {\n    width: 520px;\n    height: fit-content;\n    background-color: #ffffff;\n    background-image: url('../../assets/Admin\\ Login.png');\n    background-size: cover;\n    background-repeat: no-repeat;\n    border: 4px solid #FFFFFF;\n    border-radius: 20px;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    justify-content: center;\n    gap: 8px;\n    padding: 20px; \n    position: relative;     \n    box-sizing: border-box;\n}\n\n.otp_container > h1 {\n    font-size: 24px;\n    font-weight: 500;\n    color: #000000;\n    text-align: center;\n    margin: 0;\n}\n\n.otp-input-box {\n    width: 100%;\n    box-sizing: border-box;\n}\n\n.otp-input-box > div {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    flex-wrap: nowrap;\n    width: 100%;\n}\n\n.otp-input-box > div > input {\n    width: 34px !important;\n    height: 42px !important;\n    border: 1px solid #515151;\n    border-radius: 6px;\n    font-size: 20px;\n    font-weight: 700;\n    font-family: 'Quicksand';\n    margin: 0 !important;\n    background-color: transparent;\n    text-align: center;\n    outline: none;\n    flex-shrink: 0;\n    box-sizing: border-box;\n}\n\n.otp-input-box > div > input:focus {\n    border-color: #234B9A;\n    border-width: 2px;\n}\n\n.otpreset {\n    color: #43454A;\n    font-size: 16px;\n    font-weight: 400;\n    text-align: center;\n    margin: 0;\n}\n\n.otpreset button {\n    color: #234B9A;\n    font-size: 20px;\n    font-weight: 600;\n    cursor: pointer;\n    border: none;\n    background-color: transparent;\n}\n\n.resendbtn{\n    font-size: 16px;\n}\n\n.closeModal {\n    position: absolute;\n    top: 12px;\n    right: 16px;\n    width: fit-content;\n    height: fit-content;\n    font-size: 25px;\n    font-weight: 600;\n}\n\n.closeModal svg {\n    cursor: pointer;\n}\n\n@media (max-width: 560px) {\n    .otp_container {\n        width: 95vw;\n        padding: 16px 10px 24px 10px;\n        gap: 14px;\n    }\n\n    .otp-input-box > div > input {\n        width: 24px !important;\n        height: 34px !important;\n        font-size: 14px;\n        border-radius: 5px;\n    }\n\n    .otp-input-box > div {\n        gap: 4px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
